<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. アンチウェブシェル (WSFinder)</b></h3><br>
    <b-row style="padding-left:25px;">
      <b-col>
        <h4><b>{{start}}.1 概要</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.1.1. 基本情報</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                  <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">period</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.2. 契約状況</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Status</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Contracted</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{wsfinder_summary && wsfinder_summary.wsf_status && wsfinder_summary.wsf_status || 0}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.3. セキュリティに関わるイベントの総数</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Events</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detected</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{(wsfinder_summary && wsfinder_summary.security_event ? wsfinder_summary.security_event.detect : 0) | number}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Isolation</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder_summary && wsfinder_summary.security_event && wsfinder_summary.security_event.backup ? wsfinder_summary.security_event.backup : 0) | number}}
                  </th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.4. WebサーバとWS-Finderの状況</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" colspan="5">Server</th>
                </tr>
                <tr>
                  <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">No.</th> -->
                  <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</th>
                  <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">IP</th>
                  <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">OS</th>
                  <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Status</th>
                </tr>
                <tr v-for="(WSF_3_1_4, index) in wsfinder_summary.agent_info" :key="index">
                  <!-- <th style="border:1px solid; text-align: center;">{{(index+1)}}</th> -->
                  <th style="border:1px solid; text-align: center;">{{WSF_3_1_4.host}}</th>
                  <th style="border:1px solid; text-align: center;">{{WSF_3_1_4.ip_addr}}</th>
                  <th style="border:1px solid; text-align: center;">{{WSF_3_1_4.os_type}}</th>
                  <th style="border:1px solid; text-align: center;">{{WSF_3_1_4.deleted_at == '-' ? 'On' : 'Off(Deleted)'}}</th>
                </tr>
                <tr v-if="!wsfinder_summary || !wsfinder_summary.agent_info || wsfinder_summary.agent_info.length < 1">
                  <!-- <th style="border:1px solid; text-align: center;">N/A</th> -->
                  <th style="border:1px solid; text-align: center;">N/A</th>
                  <th style="border:1px solid; text-align: center;">N/A</th>
                  <th style="border:1px solid; text-align: center;">N/A</th>
                  <th style="border:1px solid; text-align: center;">N/A</th>
                </tr>
              </tbody>
            </table>
            <!-- 도메인별은 없음 -->
          </b-col>
        </b-row>
        <h4><b>{{start}}.2 監視状況</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.2.1. ウェブシェル検知と隔離した総数（日次）</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.1.1. ウェブシェル検知（日次）</b></h5>
                <line-chart :chartData="WSFinder_Daily_Detection_Total"></line-chart>
              </b-col>
            </b-row>
            <hr>
            <h5><b>{{start}}.2.2. 個別サーバに対する検知と隔離した総数（日次） </b></h5>
            <b-row style="padding-left:25px;">
              <b-col sm="12" v-for="(server, index) in WSFinder_Daily_Detection_Server" v-bind:key="index" v-if="index + 1 <= wsfinder_summary.agent_info.length">
                <h5><b>{{start}}.2.2.{{index + 1}}. ウェブシェル検知と隔離の数 ({{server.host}})</b></h5>
                <stackedVerticalBarChart :index="index" :series="server.series" :categories="server.categories" />
              </b-col>
              <b-col>
                <line-chart v-if="WSFinder_Daily_Detection_Server.length < 1" :chartData="DEFAULT_CHART_DATA"></line-chart>
              </b-col>
            </b-row>
            <hr>
            <h5><b>{{start}}.2.3. ウェブシェル検知と隔離（サーバ毎）</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.3.1. 総数（サーバ毎）</b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" rowspan="2">Server Name</th>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" colspan="2">Events</th>
                      <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" rowspan="2">Deleted</th> -->
                    </tr>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected</th>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Isolation</th>
                      <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Total</th> -->
                    </tr>
                    <tr v-for="WSF_3_2_3_1 in wsfinder_summary.domain_per_number" :key="WSF_3_2_3_1.id">
                      <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_1.host}}</th>
                      <!-- <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_1.dt_cnt - WSF_3_2_3_1.bp_cnt | number}}</th> -->
                      <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_1.dt_cnt | number}}</th>
                      <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_1.bp_cnt | number}}</th>
                      <!-- <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_1.deleted_at || '-'}}</th> -->
                    </tr>
                    <tr v-if="!wsfinder_summary.domain_per_number || wsfinder_summary.domain_per_number.length < 1">
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;" colspan="2">N/A</th>
                      <!-- <th style="border:1px solid; text-align: center;">N/A</th> -->
                      <!-- <th style="border:1px solid; text-align: center;">N/A</th> -->
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.2.3.2 トップ１０イベント（総数）  <small class="float-right">List of last 50</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                  <tbody>
                      <tr>

                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; min-width:80px; width:10%;">Category</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Pattern</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Path</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:150px;">Detected Timestamp</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:70px;">Isolation</th>
                      </tr>
                      <tr v-for="WSF_3_2_3_2 in wsfinder_summary.total_event" :key="WSF_3_2_3_2.index">
                        <th class="p-2" style="border:1px solid; text-align: center;">{{WSF_3_2_3_2.category}}</th>
                        <th class="p-2" style="border:1px solid; max-width:100px; text-align: left;">{{WSF_3_2_3_2.code | truncate(100) }}</th>
                        <th class="p-2" style="border:1px solid; text-align: left;">{{WSF_3_2_3_2.path | truncate(100)}}</th>
                        <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_2.created_at | datetime}}</th>
                        <th style="border:1px solid; text-align: center;">
                          <span v-if="WSF_3_2_3_2.is_backup" class="text-info"> O </span>
                          <span v-else class="text-danger"> X </span>
                          <!-- <b-badge :variant="WSF_3_2_3_2.is_backup ? 'success' : 'danger'">{{WSF_3_2_3_2.is_backup ? 'O' : ''}}</b-badge> -->
                        </th>
                      </tr>
                      <tr v-if="wsfinder_summary.total_event && wsfinder_summary.total_event.length < 1">
                        <th class="p-2" style="border:1px solid; text-align: center;">N/A</th>
                        <th class="p-2" style="border:1px solid; max-width:100px; text-align: center;">N/A</th>
                        <th class="p-2" style="border:1px solid; text-align: center;">N/A</th>
                        <th style="border:1px solid; text-align: center; max-width:90px">N/A</th>
                        <th style="border:1px solid; text-align: center;">N/A</th>
                      </tr>
                  </tbody>
                </table>
                <!-- <h5><b>{{start}}.2.2.3. Events </b></h5> -->
                <div v-for="(WSF_3_2_3_3, index) in wsfinder_summary.server_event" :key="WSF_3_2_3_3.id">
                <h5><b>{{start}}.2.3.{{index + 1 + 2}} トップ１０イベント ({{WSF_3_2_3_3[0].host}}) <small class="float-right">List of last 10</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                  <tbody>
                      <tr>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; min-width:80px; width:10%;">Category</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Pattern</th>
                          <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Path</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; min-width:160px;">Detected Timestamp</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:80px;">Isolated</th>
                      </tr>
                      <tr v-for="WSF_3_2_3_3_1 in WSF_3_2_3_3" :key="WSF_3_2_3_3_1.id">
                        <th class="p-2" style="border:1px solid; text-align: center;">{{WSF_3_2_3_3_1.category || 'None'}}</th>
                        <th class="p-2" style="border:1px solid; text-align: left;">{{WSF_3_2_3_3_1.code | truncate(100)}}</th>
                        <th class="p-2" style="border:1px solid; text-align: left;">{{WSF_3_2_3_3_1.path | truncate(100)}}</th>
                        <th style="border:1px solid; text-align: center;">{{WSF_3_2_3_3_1.created_at | datetime}}</th>
                        <th style="border:1px solid; text-align: center;">

                          <span v-if="(WSF_3_2_3_3_1.is_backup === 'N/A' || WSF_3_2_3_3_1.is_backup === '')"> N/A </span>
                          <span v-else-if="WSF_3_2_3_3_1.is_backup" class="text-info"> O </span>
                          <span v-else class="text-danger"> X </span>

                          <!-- <b-badge :variant="WSF_3_2_3_3_1.is_backup ? 'success' : 'danger'">{{WSF_3_2_3_3_1.is_backup ? 'O' : 'X'}}</b-badge> -->
                        </th>
                      </tr>
                  </tbody>
                </table>
                </div>
              </b-col>
            </b-row>
            <!-- <h5><b>{{start}}.2.4. Agent Check Table</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.4.1. Status (Agent 1 name & IP address)</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                      <tr>
                        <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">No.</td>
                        <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                        <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Scan Count</td>
                        <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Scan Folder</td>
                      </tr>
                      <tr>
                        <td style="border:1px solid; text-align: center;">{{`1`}}</td>
                        <td style="border:1px solid; text-align: center;">{{`server 1`}}</td>
                        <td style="border:1px solid; text-align: center;">{{`100`}}</td>
                        <td style="border:1px solid; text-align: center;">{{`D:/document_root/ww2/wwsh.php`}}</td>
                      </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row> -->
          </b-col>
        </b-row>
        <!-- <h4><b>{{start}}.3 Response Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.3.1. Incident Response</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.3.1.1. Alert sending status</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%"></th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detection E-mail</th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Blocking E-mail</th>
                    </tr>
                    <tr>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">Alert</th>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{60}}</th>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{5}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.3.1.2. Daily detection Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
                <h5><b>{{start}}.3.1.3. Daily isolation Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
        <h4><b>{{start}}.3  管理状況</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.3.1. ウェブシェル検知のパターン</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.3.1.1. 更新回数</b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <!-- <tr>
                      <th colspan="2" style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">
                        Pattern
                      </th>
                    </tr> -->
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;"></th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Totals</th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Updated</th>
                    </tr>
                    <tr>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">Pattern</th>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{wsfinder_summary && wsfinder_summary.pattern_count && wsfinder_summary.pattern_count.total || 0}}</th>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{wsfinder_summary && wsfinder_summary.pattern_count && wsfinder_summary.pattern_count.month || 0}}</th>
                    </tr>
                  </tbody>
                </table>
                <!-- <h5><b>{{start}}.3.1.2. Daily update</b></h5>
                <line-chart :chartData="WSFinder_Daily_Pattern"></line-chart> -->
                <hr>
                <h5><b>{{start}}.3.1.2. 更新された検知パターン  <small class="float-right">List of last 10</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Date</th>
                      <th style="border:1px solid; max-width:30px; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Category</th>
                      <th style="border:1px solid; max-width:100px; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Type</th>
                      <th style="border:1px solid; max-width:100px; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Code</th>
                    </tr>

                    <tr v-for="(WSF_3_4_1_3, index) in wsfinder_summary.pattern_update" :key="index">
                      <th class="p-2" style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: center; width:100px; ">{{WSF_3_4_1_3.created_at | date}}</th>
                      <th class="p-2" style="border:1px solid; max-width:50px; background-Color:#f0f3f5; text-align: center; width:100px;">{{codes.code_category[WSF_3_4_1_3.category] || '-'}}</th>
                      <th class="p-2" style="border:1px solid; max-width:50px; background-Color:#f0f3f5; text-align: center; width:100px;">{{codes.WSFINDER_CODE_TYPE[WSF_3_4_1_3.type]}}</th>
                      <th class="p-2" style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: left; ">
                        {{WSF_3_4_1_3.code || '-'}}
                      </th>
                    </tr>
                    <tr v-if="wsfinder_summary.pattern_update && wsfinder_summary.pattern_update.length < 1">
                      <th style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: center; ">N/A</th>
                      <th style="border:1px solid; max-width:50px; background-Color:#f0f3f5; text-align: center;">N/A</th>
                      <th style="border:1px solid; max-width:50px; background-Color:#f0f3f5; text-align: center;">N/A</th>
                      <th style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: center; ">N/A</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWSFinder',
  props: [
    'start',
    'end',
    'from',
    'to',
    'wsfinder_recent',
    'wsfinder_summary',
    'WSFinder_Daily_Detection_Total',
    'WSFinder_Daily_Detection_Server',
    'WSFinder_Daily_Pattern',
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // Regex	Hash	URL	SSDEEP	Obfuscation
    wsfinder_rule(setting) { return _.map((JSON.parse(setting).rule || []), r => r.toLowerCase()) },
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `mounted`);
  },
}
</script>
